import { render, staticRenderFns } from "./news-detail.vue?vue&type=template&id=c4839a78&scoped=true"
import script from "./news-detail.vue?vue&type=script&lang=js"
export * from "./news-detail.vue?vue&type=script&lang=js"
import style0 from "./news-detail.vue?vue&type=style&index=0&id=c4839a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4839a78",
  null
  
)

export default component.exports